import { create } from '@terminal/utils/store/createStore';

export const DEFAULT_HISTORY_SIDEBAR_CATEGORY = 'all';

export const HISTORY_SIDEBAR_CATEGORIES = [
  DEFAULT_HISTORY_SIDEBAR_CATEGORY,
  'bookmarked',
  'scheduled',
] as const;

export type CategoryType = (typeof HISTORY_SIDEBAR_CATEGORIES)[number];

export type SettingsSection =
  | 'response-format'
  | 'response-language'
  | 'integrations';

export const DEFAULT_SETTINGS_SECTION: SettingsSection = 'response-format';

interface HistorySidebarNavigationState {
  selectedScheduledQueryId: string | null;
  settingsSection: SettingsSection | null;
}

interface HistorySidebarNavigationActions {
  setSelectedScheduledQueryId: (id: string | null) => void;
  setSettingsSection: (section: SettingsSection | null) => void;
}

type HistorySidebarNavigationStore = HistorySidebarNavigationState &
  HistorySidebarNavigationActions;

export const getHistorySidebarCategory = (
  category: string | null
): CategoryType =>
  HISTORY_SIDEBAR_CATEGORIES.find(
    historySidebarCategory => historySidebarCategory === category
  ) ?? DEFAULT_HISTORY_SIDEBAR_CATEGORY;

export const useHistorySidebarNavigation =
  create<HistorySidebarNavigationStore>(set => ({
    selectedScheduledQueryId: null,
    settingsSection: null,
    setSelectedScheduledQueryId: id => set({ selectedScheduledQueryId: id }),
    setSettingsSection: section => set({ settingsSection: section }),
  }));
